import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ List Match Products -------
const getAllMatchProducts = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.matchProduct.list + `${filter ? '?' + filter : ''}`);
    return data;
};

const GetAllMatchProductsQuery = (filter) => {
    return useQuery(['MatchProductList', filter], () => getAllMatchProducts(filter));
};

// ------------------ Add Match Product -------
const addMatchProduct = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.matchProduct.add, payload);
};

const CreateMatchProductMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addMatchProduct, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('MatchProductList');
            toastMessage('success', 'Match Product Created Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

// ------------------ Update Match Product -------
const updateMatchProduct = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.matchProduct.update + id, payload);
};

const UpdateMatchProductMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateMatchProduct, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('MatchProductList');
            toastMessage('success', 'Match Product Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

// ------------------ Delete Match Product -------
const deleteMatchProduct = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.matchProduct.delete + id);
};

const DeleteMatchProductMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteMatchProduct, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('MatchProductList');
            toastMessage('success', 'Match Product Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

// ------------------ Bulk Add Match Products -------
const bulkAddMatchProducts = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.matchProduct.bulkAdd, payload);
};

const BulkAddMatchProductsMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(bulkAddMatchProducts, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('MatchProductList');
            toastMessage('success', 'Bulk Match Products Imported Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

export {
    GetAllMatchProductsQuery,
    CreateMatchProductMutation,
    UpdateMatchProductMutation,
    DeleteMatchProductMutation,
    BulkAddMatchProductsMutation
};
